<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-autocomplete
    :value="value"
    :items="tasks"
    item-text="name"
    item-value="taskId"
    persistent-hint
    single-line
    chips
    deletable-chips
    :label="language.t('FormFields.TaskSelect.chooseTask')"
    v-bind="$attrs"
    v-on="listners"
  >
    <template
      slot="item"
      slot-scope="data"
    >
      {{ data.item.name }}
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  inheritsAttrs: false,
  data: () => ({
    list_tasks: [],
    value: []
  }),
  props: {
    tasks: Array
  },
  watch: {
  },
  computed: {
    listners() {
      return {
        ...this.$listners,
        input: event =>
          this.$emit('input', event)
      }
    }
  },
  methods: {
  }
};
</script>
